import {
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {
  MobileDetectService,
  ShareModalService,
  UserModel,
} from '@lib/gc-common';

@Component({
  selector: 'mip-profile-top-toolbar',
  templateUrl: './profile-top-toolbar.component.html',
  styleUrls: ['./profile-top-toolbar.component.scss'],
})
export class ProfileTopToolbarComponent implements OnInit {
  @Input() profile: UserModel = null;

  @Input() backFallbackReferrer = null;
  @Input() backPathReferrer = null;

  isMobile = false;
  isDesktop = false;

  constructor(private mobileDetect: MobileDetectService, private shareModalService: ShareModalService) {
    this.isMobile = this.mobileDetect.isMobile();
    this.isDesktop = !this.mobileDetect.isMobile();
  }

  ngOnInit(): void {
    // console.log('profile-top-toolbar.component->ngOnInit(): this.backPathReferrer', this.backPathReferrer);
  }

  shareProfile() {
    this.shareModalService.shareOpen({
      url: window.location.href,
      imageLeft: this.profile.getAvatarSource(),
    });
  }
}
